import React, { useRef, useCallback } from 'react';

import NetworkBackground from './NetworkBackground';
import {
  StyledRoot,
  BgOverlay,
  Orb1,
  Orb2,
  Orb3,
  Scene,
  LoginContainer,
  Brand,
  BrandLogo,
  BrandTitle,
  BrandSubtitle,
  StyledCard,
  CardHeader,
} from './styles';

type Props = {
  children: React.ReactNode;
};

export default function LoginLayout({ children }: Props) {
  const cardRef = useRef<HTMLDivElement>(null);

  const handleCardMouseMove = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    card.style.transform = `translateY(-2px) perspective(800px) rotateX(${y * -3}deg) rotateY(${x * 3}deg)`;
  }, []);

  const handleCardMouseLeave = useCallback(() => {
    const card = cardRef.current;
    if (card) {
      card.style.transform = 'translateY(0)';
    }
  }, []);

  return (
    <StyledRoot>
      <NetworkBackground />
      <BgOverlay />
      <Orb1 />
      <Orb2 />
      <Orb3 />

      <Scene>
        <LoginContainer>
          <Brand>
            <BrandLogo>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
              </svg>
            </BrandLogo>
            <BrandTitle>PRM</BrandTitle>
            <BrandSubtitle>Partner Relationship Management</BrandSubtitle>
          </Brand>

          <StyledCard ref={cardRef} onMouseMove={handleCardMouseMove} onMouseLeave={handleCardMouseLeave}>
            <CardHeader>
              <h2>Willkommen</h2>
              <p>Melde dich an um fortzufahren</p>
            </CardHeader>

            {children}
          </StyledCard>
        </LoginContainer>
      </Scene>
    </StyledRoot>
  );
}
